import React, { useEffect, useRef, useState } from 'react';
import { IoMdArrowDropdown } from 'react-icons/io';

interface Option {
  value: any;
  name: string;
}

interface CustomSelectProps {
  options: Option[];
  value: any;
  onChange: (val: any) => void;
  placeholder?: string;
  containerStyle?: React.CSSProperties;
}

export function CustomSelect({
  options,
  value,
  onChange,
  placeholder = '',
  containerStyle,
}: CustomSelectProps) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const selectedOption = options.find((opt) => opt.value === value || opt.name === value);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      id='input-customselect-wrapper'
      ref={wrapperRef}
      style={{
        border: '1px solid #414042',
        background: '#fff',
        position: 'relative',
        ...containerStyle,
      }}
    >
      <div
        id='input-customselect-container'
        className="flex-y-center flex-space-between cursor-pointer"
        style={{ padding: '8px' }}
        onClick={() => setOpen((o) => !o)}
      >
        <div id='input-customselect-selectoption'>{selectedOption ? selectedOption.name : placeholder}</div>
        <IoMdArrowDropdown id='input-customselect-selectoption-dropdown' size="1.2rem" />
      </div>

      {open && (
        <div
          id='input-customselect-options-wrapper'
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            border: '1px solid #414042',
            background: '#fff',
            zIndex: 1000,
          }}
        >
          {options.map((opt) => {
            const isSelected = opt.value === value;
            return (
              <div
                id={`input-customselect-option-${opt.name}`}
                key={opt.value}
                style={{
                  padding: '8px',
                  cursor: 'pointer',
                  background: isSelected ? '#0078d7' : 'white',
                  color: isSelected ? 'white' : 'black',
                }}
                onClick={() => {
                  onChange(opt);
                  setOpen(false);
                }}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.background = '#f2f2f2';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.background = 'white';
                  }
                }}
              >
                {opt.name}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
